/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The question as everyone will see it (it may be reworded): plain text, 1 to 2000.
 * @export
 * @interface EventQuestionPublish
 */
export interface EventQuestionPublish {
    /**
     * 
     * @type {string}
     * @memberof EventQuestionPublish
     */
    published_text: string;
}

/**
 * Check if a given object implements the EventQuestionPublish interface.
 */
export function instanceOfEventQuestionPublish(value: object): value is EventQuestionPublish {
    if (!('published_text' in value) || value['published_text'] === undefined) return false;
    return true;
}

export function EventQuestionPublishFromJSON(json: any): EventQuestionPublish {
    return EventQuestionPublishFromJSONTyped(json, false);
}

export function EventQuestionPublishFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionPublish {
    if (json == null) {
        return json;
    }
    return {
        
        'published_text': json['published_text'],
    };
}

export function EventQuestionPublishToJSON(json: any): EventQuestionPublish {
    return EventQuestionPublishToJSONTyped(json, false);
}

export function EventQuestionPublishToJSONTyped(value?: EventQuestionPublish | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'published_text': value['published_text'],
    };
}

